var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-drawer",
    {
      attrs: {
        visible: _vm.visible,
        direction: "btt",
        size: "90%",
        title: _vm.email.subject,
        "append-to-body": true,
        "destroy-on-close": true,
        "with-header": true,
        "close-on-press-escape": false,
        modal: true,
        "before-close": _vm.handleClose,
        "custom-class": "compose-email-drawer",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "mbl-drawer" }, [
        _c("div", { staticClass: "mbl-info" }, [
          _c("div", { staticClass: "info-row" }, [
            _c("span", { staticClass: "info-label" }, [_vm._v("发件人：")]),
            _c(
              "span",
              { staticClass: "info-value" },
              [
                _vm.email.sender.address != _vm.email.sender.name
                  ? [_vm._v(_vm._s(_vm.email.sender.name) + "<")]
                  : _vm._e(),
                _vm._v(_vm._s(_vm.email.sender.address)),
                _vm.email.sender.address != _vm.email.sender.name
                  ? [_vm._v(">")]
                  : _vm._e(),
              ],
              2
            ),
            _c("span", { staticClass: "info-label ml-20" }, [
              _vm._v("发送时间："),
            ]),
            _c("span", { staticClass: "info-value" }, [
              _vm._v(_vm._s(_vm.email.receivedDate)),
            ]),
          ]),
          _c("div", { staticClass: "info-row" }, [
            _c("span", { staticClass: "info-label" }, [_vm._v("收件人：")]),
            _c("span", { staticClass: "info-value" }, [
              _vm._v(
                _vm._s(_vm.email.recipients.map((e) => e.address).join("、"))
              ),
            ]),
          ]),
          _vm.email.cc && _vm.email.cc.length
            ? _c("div", { staticClass: "info-row" }, [
                _c("span", { staticClass: "info-label" }, [_vm._v("抄送：")]),
                _c("span", { staticClass: "info-value" }, [
                  _vm._v(_vm._s(_vm.email.cc.map((e) => e.address).join("、"))),
                ]),
              ])
            : _vm._e(),
          _vm.email.attachments && _vm.email.attachments.length
            ? _c("div", { staticClass: "info-row attachments-row" }, [
                _c("span", { staticClass: "info-label" }, [_vm._v("附件：")]),
                _c(
                  "div",
                  { staticClass: "attachment-list" },
                  _vm._l(_vm.email.attachments, function (file, idx) {
                    return _c(
                      "div",
                      {
                        key: idx,
                        staticClass: "attachment-tag",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.downLoad(file)
                          },
                        },
                      },
                      [
                        file.fileName.split(".").pop().toLowerCase() == "pdf"
                          ? _c("svg-icon", {
                              attrs: { iconClass: "pdf", className: "icon" },
                            })
                          : file.fileName.split(".").pop().toLowerCase() ==
                            "xlsx"
                          ? _c("svg-icon", {
                              attrs: { iconClass: "xlsx", className: "icon" },
                            })
                          : _c("i", { staticClass: "el-icon-document" }),
                        _c("span", [_vm._v(_vm._s(file.fileName))]),
                        _c("i", { staticClass: "el-icon-download" }),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ])
            : _vm._e(),
        ]),
        _c("div", {
          staticClass: "mbl-info-body",
          domProps: { innerHTML: _vm._s(_vm.email.content) },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }